module.exports = __webpack_public_path__ + "img/market-solution.282ee77f.png";